module.exports = __webpack_public_path__ + "img/20040.eed73c62.png";